var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFabitsBasketRowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 373,
    zoomAndPan: "magnify",
    viewBox: "235.089844 225 279.75 300",
    height: 400,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "97104ce80d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 235.089844 225 L 514.839844 225 L 514.839844 525 L 235.089844 525 Z M 235.089844 225 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f4ff",
    d: "M 513.8125 305.710938 L 513.8125 443.6875 L 374.996094 523.859375 L 236.179688 443.6875 L 236.179688 305.710938 L 236.777344 306.070312 L 374.457031 226.558594 L 512.671875 306.371094 Z M 513.8125 305.710938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 299.140625 420.664062 L 261.484375 458.320312 L 261.722656 458.5 L 349.210938 371.011719 L 348.972656 370.832031 Z M 299.140625 420.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 305.136719 420.664062 L 265.261719 460.539062 L 265.5625 460.660156 L 281.390625 444.828125 L 353.046875 373.171875 L 352.75 373.050781 Z M 305.136719 420.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 311.132812 420.664062 L 293.144531 438.59375 L 269.039062 462.699219 L 269.339844 462.878906 L 281.390625 450.765625 L 323.304688 408.910156 L 353.167969 378.988281 L 356.824219 375.390625 L 356.527344 375.210938 Z M 311.132812 420.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 317.070312 420.664062 L 293.144531 444.589844 L 272.875 464.917969 L 273.117188 465.035156 L 360.605469 377.546875 L 360.363281 377.429688 Z M 317.070312 420.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 323.066406 420.664062 L 293.144531 450.585938 L 276.652344 467.074219 L 276.894531 467.253906 L 364.382812 379.765625 L 364.140625 379.585938 Z M 323.066406 420.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 329.0625 420.664062 L 280.433594 469.292969 L 280.730469 469.414062 L 368.21875 381.925781 L 367.917969 381.804688 L 364.921875 384.746094 Z M 329.0625 420.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 335.058594 420.664062 L 293.144531 462.515625 L 284.210938 471.453125 L 284.507812 471.632812 L 347.230469 408.910156 L 353.167969 402.914062 L 371.996094 384.144531 L 371.695312 383.964844 L 364.921875 390.742188 Z M 335.058594 420.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 340.996094 420.664062 L 293.144531 468.515625 L 288.046875 473.671875 L 288.289062 473.789062 L 353.167969 408.910156 L 374.996094 387.144531 L 374.996094 386.722656 L 364.921875 396.738281 Z M 340.996094 420.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 287.207031 420.664062 L 253.867188 453.941406 L 254.167969 454.121094 L 281.390625 426.839844 L 299.378906 408.910156 L 341.65625 366.636719 L 341.355469 366.457031 Z M 287.207031 420.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 281.390625 361.058594 L 299.921875 342.53125 L 299.679688 342.410156 L 293.144531 348.886719 L 236.179688 405.910156 L 236.179688 406.332031 Z M 281.390625 361.058594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 239.535156 408.910156 L 281.390625 367.054688 L 303.699219 344.75 L 303.457031 344.566406 L 299.140625 348.886719 L 236.179688 411.847656 L 236.179688 412.269531 Z M 239.535156 408.910156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 245.53125 408.910156 L 281.390625 372.992188 L 307.535156 346.90625 L 307.234375 346.785156 L 305.136719 348.886719 L 293.144531 360.820312 L 236.179688 417.84375 L 236.179688 418.265625 Z M 245.53125 408.910156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 251.46875 408.910156 L 281.390625 378.988281 L 311.3125 349.125 L 311.011719 348.945312 L 293.144531 366.816406 L 239.296875 420.664062 L 236.179688 423.839844 L 236.179688 424.261719 Z M 251.46875 408.910156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 257.464844 408.910156 L 315.089844 351.285156 L 314.851562 351.164062 L 293.144531 372.8125 L 245.292969 420.664062 L 236.179688 429.835938 L 236.179688 430.257812 Z M 257.464844 408.910156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 263.460938 408.910156 L 318.867188 353.503906 L 318.628906 353.324219 L 236.179688 435.773438 L 236.179688 436.191406 Z M 263.460938 408.910156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 269.457031 408.910156 L 322.707031 355.660156 L 322.40625 355.542969 L 293.144531 384.746094 L 257.285156 420.664062 L 236.179688 441.769531 L 236.179688 442.191406 Z M 269.457031 408.910156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 275.453125 408.910156 L 281.390625 402.914062 L 326.484375 357.878906 L 326.183594 357.699219 L 293.144531 390.742188 L 263.222656 420.664062 L 238.695312 445.1875 L 238.996094 445.367188 Z M 275.453125 408.910156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 330.261719 360.039062 L 330.023438 359.917969 L 293.144531 396.738281 L 269.21875 420.664062 L 242.535156 447.40625 L 242.773438 447.527344 Z M 330.261719 360.039062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 287.386719 408.910156 L 334.039062 362.257812 L 333.800781 362.078125 L 246.3125 449.566406 L 246.550781 449.746094 Z M 287.386719 408.910156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 352.988281 420.664062 L 295.601562 478.046875 L 295.902344 478.167969 L 374.996094 399.074219 L 374.996094 398.65625 Z M 352.988281 420.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 358.984375 420.664062 L 299.378906 480.207031 L 299.679688 480.386719 L 353.167969 426.839844 L 371.15625 408.910156 L 374.996094 405.070312 L 374.996094 404.652344 Z M 358.984375 420.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 352.988281 492.441406 L 341.117188 504.3125 L 341.414062 504.492188 L 365.160156 480.6875 L 374.996094 470.851562 L 374.996094 470.433594 Z M 352.988281 492.441406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 358.984375 492.441406 L 344.894531 506.53125 L 345.191406 506.652344 L 374.996094 476.847656 L 374.996094 476.429688 Z M 358.984375 492.441406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 281.390625 355.0625 L 296.140625 340.371094 L 295.84375 340.191406 L 287.207031 348.886719 L 236.179688 399.914062 L 236.179688 400.335938 Z M 281.390625 355.0625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 254.167969 316.085938 L 236.179688 334.074219 L 236.179688 334.496094 L 254.40625 316.265625 Z M 254.167969 316.085938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 239.535156 337.132812 L 258.183594 318.425781 L 257.945312 318.304688 L 236.179688 340.070312 L 236.179688 340.492188 Z M 239.535156 337.132812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 245.53125 337.132812 L 262.023438 320.644531 L 261.722656 320.460938 L 236.179688 346.066406 L 236.179688 346.488281 Z M 245.53125 337.132812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 251.46875 337.132812 L 265.800781 322.800781 L 265.5 322.679688 L 239.296875 348.886719 L 236.179688 352.0625 L 236.179688 352.484375 Z M 251.46875 337.132812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 257.464844 337.132812 L 269.578125 325.019531 L 269.339844 324.839844 L 236.179688 358 L 236.179688 358.480469 Z M 257.464844 337.132812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 263.460938 337.132812 L 273.355469 327.179688 L 273.117188 327.058594 L 236.179688 363.996094 L 236.179688 364.417969 Z M 263.460938 337.132812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 269.457031 337.132812 L 277.195312 329.398438 L 276.894531 329.21875 L 257.285156 348.886719 L 236.179688 369.992188 L 236.179688 370.414062 Z M 269.457031 337.132812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 275.453125 337.132812 L 280.972656 331.617188 L 280.671875 331.4375 L 263.222656 348.886719 L 236.179688 375.988281 L 236.179688 376.410156 Z M 275.453125 337.132812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 284.75 333.773438 L 284.507812 333.59375 L 269.21875 348.886719 L 236.179688 381.984375 L 236.179688 382.40625 L 281.390625 337.132812 Z M 284.75 333.773438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 287.386719 337.132812 L 288.527344 335.992188 L 288.289062 335.8125 L 236.179688 387.921875 L 236.179688 388.34375 L 281.390625 343.128906 Z M 287.386719 337.132812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 250.328125 313.925781 L 236.179688 328.136719 L 236.179688 328.558594 L 250.628906 314.046875 Z M 250.328125 313.925781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 238.996094 307.332031 L 236.179688 310.148438 L 236.179688 310.570312 L 239.238281 307.511719 Z M 238.996094 307.332031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 242.773438 309.550781 L 236.179688 316.144531 L 236.179688 316.566406 L 243.015625 309.667969 Z M 242.773438 309.550781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 246.550781 311.707031 L 236.179688 322.140625 L 236.179688 322.5625 L 246.851562 311.886719 Z M 246.550781 311.707031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 364.921875 492.441406 L 348.730469 508.691406 L 348.972656 508.871094 L 353.167969 504.613281 L 374.996094 482.84375 L 374.996094 482.425781 Z M 364.921875 492.441406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 370.917969 492.441406 L 364.921875 498.4375 L 352.507812 510.910156 L 352.75 511.027344 L 353.167969 510.609375 L 374.996094 488.839844 L 374.996094 488.421875 Z M 370.917969 492.441406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 356.285156 513.066406 L 356.585938 513.246094 L 374.996094 494.839844 L 374.996094 494.359375 L 364.921875 504.433594 Z M 356.285156 513.066406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 360.0625 515.285156 L 360.363281 515.40625 L 374.996094 500.773438 L 374.996094 500.355469 L 364.921875 510.429688 Z M 360.0625 515.285156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 363.902344 517.445312 L 364.140625 517.625 L 374.996094 506.769531 L 374.996094 506.351562 L 364.921875 516.363281 Z M 363.902344 517.445312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 367.917969 519.78125 L 374.996094 512.765625 L 374.996094 512.347656 L 367.679688 519.664062 Z M 367.917969 519.78125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 371.757812 522 L 374.996094 518.765625 L 374.996094 518.34375 L 371.457031 521.820312 Z M 371.757812 522 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 364.921875 420.664062 L 303.21875 482.425781 L 303.457031 482.546875 L 353.167969 432.835938 L 374.996094 411.070312 L 374.996094 410.648438 Z M 364.921875 420.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 370.917969 420.664062 L 306.996094 484.585938 L 307.234375 484.765625 L 353.167969 438.832031 L 374.996094 417.066406 L 374.996094 416.644531 Z M 370.917969 420.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 310.773438 486.804688 L 311.074219 486.984375 L 317.308594 480.6875 L 374.996094 423 L 374.996094 422.582031 Z M 310.773438 486.804688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 314.550781 488.960938 L 314.851562 489.140625 L 323.304688 480.6875 L 353.167969 450.765625 L 374.996094 428.996094 L 374.996094 428.578125 L 364.921875 438.59375 Z M 314.550781 488.960938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 318.390625 491.179688 L 318.628906 491.359375 L 329.242188 480.6875 L 353.167969 456.761719 L 374.996094 434.992188 L 374.996094 434.574219 L 364.921875 444.589844 Z M 318.390625 491.179688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 323.066406 492.441406 L 322.167969 493.339844 L 322.40625 493.519531 L 353.167969 462.757812 L 374.996094 440.992188 L 374.996094 440.570312 L 364.921875 450.585938 Z M 323.066406 492.441406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 329.0625 492.441406 L 325.945312 495.558594 L 326.246094 495.738281 L 341.234375 480.6875 L 374.996094 446.925781 L 374.996094 446.507812 Z M 329.0625 492.441406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 335.058594 492.441406 L 329.722656 497.777344 L 330.023438 497.894531 L 347.230469 480.6875 L 353.167969 474.691406 L 374.996094 452.921875 L 374.996094 452.503906 L 364.921875 462.515625 Z M 335.058594 492.441406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 340.996094 492.441406 L 333.558594 499.933594 L 333.800781 500.113281 L 353.167969 480.6875 L 374.996094 458.917969 L 374.996094 458.5 L 364.921875 468.515625 Z M 340.996094 492.441406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 346.992188 492.441406 L 337.335938 502.152344 L 337.578125 502.273438 L 359.164062 480.6875 L 374.996094 464.917969 L 374.996094 464.496094 L 364.921875 474.511719 Z M 346.992188 492.441406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 293.382812 408.910156 L 337.878906 364.417969 L 337.578125 364.296875 L 250.089844 451.785156 L 250.390625 451.902344 Z M 293.382812 408.910156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 293.144531 420.664062 L 257.707031 456.160156 L 257.945312 456.28125 L 345.433594 368.792969 L 345.191406 368.671875 Z M 293.144531 420.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 346.992188 420.664062 L 293.144531 474.511719 L 291.824219 475.828125 L 292.066406 476.007812 L 359.164062 408.910156 L 374.996094 393.140625 L 374.996094 392.71875 L 364.921875 402.734375 Z M 346.992188 420.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 292.066406 337.972656 L 281.210938 348.886719 L 236.179688 393.917969 L 236.179688 394.339844 L 292.363281 338.152344 Z M 292.066406 337.972656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M 504.878906 362.796875 L 447.972656 395.65625 L 447.972656 362.796875 L 504.878906 329.9375 Z M 504.878906 362.796875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#2818ff",
    d: "M 324.265625 356.679688 L 323.785156 356.382812 L 323.785156 404.59375 L 317.910156 410.886719 L 311.554688 396.796875 L 305.195312 403.574219 L 298.839844 389.480469 L 292.484375 396.257812 L 287.386719 384.984375 L 287.386719 335.332031 L 287.988281 335.695312 L 425.726562 256.121094 L 462.0625 277.109375 Z M 324.265625 356.679688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#97104ce80d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1206d2",
    d: "M 504.878906 435.773438 L 468.539062 456.761719 L 468.539062 435.773438 L 504.878906 414.785156 Z M 505.835938 363.398438 L 505.835938 328.257812 L 446.890625 362.257812 L 446.890625 397.398438 Z M 503.859375 331.675781 L 503.859375 362.257812 L 448.929688 393.980469 L 448.929688 363.398438 Z M 514.832031 306.3125 L 514.769531 444.289062 L 374.996094 525 L 235.160156 444.289062 L 235.160156 305.171875 L 374.035156 225 Z M 288.40625 337.132812 L 288.40625 384.746094 L 292.785156 394.457031 L 299.140625 387.683594 L 305.496094 401.773438 L 311.851562 394.996094 L 318.210938 409.089844 L 322.765625 404.171875 L 322.765625 356.921875 Z M 324.324219 355.480469 L 460.085938 277.109375 L 425.726562 257.261719 L 290.027344 335.632812 Z M 238.21875 305.710938 L 288.046875 334.496094 L 423.804688 256.0625 L 373.976562 227.277344 Z M 373.976562 386.421875 L 324.746094 358 L 324.746094 405.011719 L 317.550781 412.6875 L 311.195312 398.597656 L 304.835938 405.371094 L 298.480469 391.28125 L 292.125 398.054688 L 286.367188 385.222656 L 286.367188 335.933594 L 237.136719 307.449219 L 237.136719 443.148438 L 373.976562 522.121094 Z M 374.996094 384.683594 L 510.8125 306.25 L 462.183594 278.1875 L 326.363281 356.621094 Z M 512.792969 307.449219 L 375.953125 386.484375 L 375.953125 522.121094 L 512.792969 443.148438 Z M 410.554688 477.628906 L 400.179688 464.734375 L 389.804688 489.621094 L 394.84375 486.683594 L 394.84375 496.636719 L 405.515625 490.519531 L 405.515625 480.625 Z M 410.554688 477.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFabitsBasketRowIcon);
export default __webpack_public_path__ + "static/media/fabits-basket-row-icon.b2a2141c66318bcca600517e987d7a88.svg";
export { ForwardRef as ReactComponent };